import { render } from "./ControlPhone.vue?vue&type=template&id=d2d36f0c&ts=true&lang=pug"
import script from "./ControlPhone.vue?vue&type=script&setup=true&lang=ts"
export * from "./ControlPhone.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__